import { ManageWhitelistedAddressModal as SharedManageWhitelistedAddressModal } from '@valiant/ui-shared'
import {
  useUpdateWhitelistedAddressMutation,
  useRejectWhitelistedAddressMutation,
  type WhitelistedAddress,
} from '@/generated/graphql'

interface ManageWhitelistedAddressModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  address: WhitelistedAddress | null
}

export function ManageWhitelistedAddressModal({
  open,
  onOpenChange,
  address,
}: ManageWhitelistedAddressModalProps) {
  const [, updateAddress] = useUpdateWhitelistedAddressMutation()
  const [, deleteAddress] = useRejectWhitelistedAddressMutation()

  return (
    <SharedManageWhitelistedAddressModal
      open={open}
      onOpenChange={onOpenChange}
      address={address}
      onUpdateAddress={updateAddress}
      onDeleteAddress={deleteAddress}
    />
  )
}
